import { EmployeePerformanceLogs } from "./performance-logs/performance-logs";
import { EmployeePerformanceReports } from "./performance-report/performance-report";

export const PerformanceSection = () => {
  return (
    <div className="flex flex-col gap-2">
      <h1 className="text-lg font-medium tracking-wide underline underline-offset-2">
        Performance
      </h1>

      <div className="flex flex-wrap gap-6">
        <EmployeePerformanceLogs />

        <EmployeePerformanceReports />
      </div>
    </div>
  );
};
